import { ReactNode } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import BottomNav from './BottomNav';
import Toast from './Toast';

interface LayoutProps {
  children: ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  const location = useLocation();
  const navigate = useNavigate();

  // Handle Telegram back button
  useEffect(() => {
    const tg = window.Telegram?.WebApp;
    if (!tg) return;

    const handleBack = () => {
      if (location.pathname !== '/') {
        navigate(-1);
      }
    };

    if (location.pathname !== '/') {
      tg.BackButton.show();
      tg.BackButton.onClick(handleBack);
    } else {
      tg.BackButton.hide();
    }

    return () => {
      tg.BackButton.offClick(handleBack);
    };
  }, [location.pathname, navigate]);

  // Hide bottom nav on certain pages
  const hideBottomNav = ['/chats/'].some(path => location.pathname.includes(path));

  return (
    <div className="min-h-screen pb-20 safe-area-bottom">
      <main className="p-4">
        {children}
      </main>
      {!hideBottomNav && <BottomNav />}
      <Toast />
    </div>
  );
}
